import * as ApiHelper from "../../../../api/ApiHelper";
import { formatNullable } from "../../../../api/ApiHelper";
import type { LineItem, SubLineItem } from "../models/CartData";
import { isProductPMA } from "../../../ProductDescriptor/v1/productDescriptorUtils";
import { isKITProduct } from "../../../../models/ProductData";
import { toMapFn } from "../../../../utils/reducers";
import { naiveTrackCartContents } from "~/feature/Analytics/ga/abandonment";
import { resolveBulkAddUrl } from "~/utils/url/urlUtils";
import { registerCallProcessor, scheduleCall } from "~/feature/cart/cart/api/CartService";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";
import { getCurrentBrowserTimezone } from "~/utils/dateUtils";
import { isBEPriceCalculationEnabled } from "~/utils/features";

export interface AddToCartItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  netPrice: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  priceUnit: number;
  comment?: string;
  selectedDeliveryDate: Date | null;
  selectedDeliveryDateIsManual: boolean;
  // estimatedDeliveryDate?: Date,
  primaryWarehouseCode: string;
  contractNumber?: string;
  contractLine?: string;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  fifteenDigit: boolean;
  priceReference: string;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  isPMA: boolean;
  position?: number;

  // Quote specific fields
  quoteLine?: string;
  quoteNumber?: string;
  quoteScheduleLineNum?: string;
  quoteMinQuantity?: number;
  isBundled?: boolean;
  quoteExpiryDate?: Date | null;
  logisticalComment?: string;
  estimatedShippingDate?: Date | null;

  restrictedPackage: boolean;
  optionalParts?: AddToCartPartItem[];
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  surcharge: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  tariffSurchargeApplicable: boolean;
  customerOrderNumber?: string;
  originCountry: string;

  // Sales campaign stuff
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  specialPrice?: boolean;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  saleNetPrice?: number;

  salesCampaignCode?: string;

  // For contracts
  contractOpenQuantity?: number;

  // Recommendation
  recommendationType?: string;
  recommendationPlace?: string;
}

export interface AddToCartPartItem {
  productCode: string;
  quantity: number;
  packageCode: string;
  packageSize: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  netPrice: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  priceUnit: number;
  primaryWarehouseCode: string;
  partTypeCode: string;
  manualUpdated: boolean;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  surcharge: number;
  originCountry: string;
}

export interface AddToCartApiItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;

  /**
   * TODO: Kick this out of ADD TO CART API, it's revelant only for quote stuff.
   */
  confirmedQuantity?: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   *
   * Needs to be per piece or BE freaks out
   * TODO: Update BE to accept per {unitPrice} pieces
   */
  netPrice: number;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  priceUnit: number;
  comment?: string;
  selectedDeliveryDate?: string;
  selectedDeliveryDateIsManual: boolean;
  // estimatedDeliveryDate?: string;
  primaryWarehouseCode?: string;
  pnaCall?: boolean;
  contractNumber?: string;
  contractLine?: string;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   *
   * Indicates that the price is at package level, not product level
   */
  fifteenDigit: boolean;
  priceReference?: string;

  // Quote specific fields
  quoteLine?: string;
  quoteNumber?: string;
  quoteScheduleLineNum?: string;
  quoteMinQuantity?: number;
  isBundled?: boolean;

  quoteExpiryDate?: string;
  logisticalComment?: string;
  estimatedShippingDate?: string;

  isRestrictedPackage: boolean;
  orderEntryNumber?: number;

  optionalParts?: AddToCartPartItem[];
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  surcharge: number;

  customerOrderNumber?: string;
  originCountry: string;

  // Sales campaign stuff
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  specialPrice?: boolean;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  saleNetPrice?: number;
  salesCampaignCode?: string;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  tariffSurchargeApplicable: boolean;
  /**
   * @deprecated as of SCHAEFF-32242.
   * This property is going to be removeded in the future.
   * It is not sent when bePriceCalculation flag is set to true.
   */
  isPMA: boolean;
}

function transform(item: AddToCartItem): AddToCartApiItem {
  const rdd = item.selectedDeliveryDate;
  // const edd = item.estimatedDeliveryDate;

  return {
    // TODO -  SCHAEFF-32242 - During post cleanup, stop doing a spread here.
    ...item,
    selectedDeliveryDate: formatNullable(rdd),
    quoteExpiryDate: formatNullable(item.quoteExpiryDate),
    estimatedShippingDate: formatNullable(item.estimatedShippingDate),
    isRestrictedPackage: item.restrictedPackage,
    orderEntryNumber: item.position,
    // estimatedDeliveryDate: edd ? format(edd) : undefined,
  };
}

export function fromLineItem(data: LineItem, subLineItems: SubLineItem[], product: ProductDescriptor): AddToCartItem {
  const subProductTypes = isKITProduct(product.base)
    ? toMapFn(
        product.base.optionalParts,
        (p) => p.product.code,
        (p) => p.type,
      )
    : {};

  let netPrice;
  if (data.quoteLine || data.contractLine) {
    netPrice = data.netPrice?.value ?? 0;
  } else {
    netPrice = data.actualNetPrice?.value ?? 0;
  }

  return {
    productCode: product.base.code,
    packageSize: data.packSize,
    packageCode: data.packCode,
    quantity: data.quantity,
    netPrice: netPrice,
    priceUnit: data.netPrice?.unit ?? 1,
    comment: data.comment,
    selectedDeliveryDate: data.deliveryDate,
    selectedDeliveryDateIsManual: data.manuallySetRDD,
    // estimatedDeliveryDate: (data.edd && data.edd.type === 'estimate') ? data.edd.date : undefined,
    primaryWarehouseCode: data.primaryWarehouseCode,
    contractNumber: data.contractNumber,
    contractLine: data.contractLine,
    fifteenDigit: product.isMultiPrice || false,
    priceReference: data.priceReference,
    isPMA: isProductPMA(product),

    // Quote specific fields
    quoteLine: data.quoteLine.split(":")[0],
    quoteScheduleLineNum: data.quoteLine.split(":")[1],
    quoteNumber: data.quoteNumber,
    quoteMinQuantity: data.minimumQty,
    isBundled: data.isBundled,

    quoteExpiryDate: data.quoteExpiryDate,
    logisticalComment: data.logisticalComment,
    estimatedShippingDate: data.estimatedShippingDate,

    restrictedPackage: data.restrictedPackage,

    optionalParts:
      subLineItems.length === 0
        ? undefined
        : subLineItems.map((item) => ({
            productCode: item.productCode,
            quantity: item.quantity,
            netPrice: item.netPrice?.value ?? 0,
            priceUnit: item.netPrice?.unit ?? 1,
            primaryWarehouseCode: item.primaryWarehouseCode,
            packageCode: item.packCode,
            packageSize: item.packSize ?? 1,
            manualUpdated: true,
            partTypeCode: subProductTypes[item.productCode] ?? "",
            surcharge: item.netPrice?.surcharge ?? 0,
            originCountry: item.countryOfOrigin,
          })),
    surcharge: data.netPrice?.surcharge ?? 0,
    tariffSurchargeApplicable: !!data.netPrice?.tariffSurcharge,
    customerOrderNumber: data.customerOrderNumber,
    originCountry: data.countryOfOrigin,

    specialPrice: data.saleCampaignEnabled,
    salesCampaignCode: data.saleCampaignCode,
    saleNetPrice: data.saleCampaignEnabled ? data.actualSalePrice?.value ?? 0 : undefined,
  };
}

export function sendAddToCart(item: AddToCartItem | AddToCartItem[], skipTracking = false) {
  return sendBulkAddToCart(Array.isArray(item) ? item : [item], skipTracking);
}

export function sendBulkAddToCart(items: AddToCartItem[], skipTracking = false) {
  return scheduleCall("add", { items, skipTracking });
}

export const DEPRECATED_ATTRIBUTES_TO_REMOVE = [
  "netPrice",
  "priceUnit",
  "fifteenDigit",
  "surcharge",
  "specialPrice",
  "saleNetPrice",
  "tariffSurchargeApplicable",
  "isPMA",
];

const apiUrl = resolveBulkAddUrl();
registerCallProcessor({
  type: "add",
  canBeExecuted: (ongoingCalls) => {
    const isDeleteOngoing = ongoingCalls.some((call) => call.type === "delete" || call.type === "deleteCart");
    return !isDeleteOngoing;
  },
  execute: async ({ items, skipTracking }: { items: AddToCartItem[]; skipTracking: boolean }) => {
    const body = {
      items: items.map(transform),
      userTimeZone: getCurrentBrowserTimezone(),
    };

    if (isBEPriceCalculationEnabled()) {
      DEPRECATED_ATTRIBUTES_TO_REMOVE.forEach((attr) => {
        body.items.forEach((item) => {
          // @ts-expect-error - This code will be removed in two releases
          delete item[attr];
          item.optionalParts?.forEach((part) => {
            // @ts-expect-error - This code will be removed in two releases
            delete part[attr];
          });
        });
      });
    }

    const packageToCartForm = JSON.stringify(body);

    return fetch(apiUrl, {
      body: packageToCartForm,
      cache: "no-cache",
      credentials: "same-origin",
      method: "POST",
      mode: "cors",
      headers: {
        dataType: "json",
        "content-type": "application/json",
        CSRFToken: ApiHelper.getCsrfValue(),
      },
      redirect: "follow",
    })
      .then((response) => {
        if (response.redirected) {
          window.location.reload();
        }
        return response;
      })
      .then((result) => {
        window.SCHA.updateMinicart?.();
        return result;
      })
      .then((result) => {
        if (!skipTracking) {
          naiveTrackCartContents();
        }
        return result;
      });
  },
});
